import { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { Patient } from '../../../domain/entities';
import SidebarLayout from '../../layouts/SidebarLayout';
import { PatientForm } from './components/PatientForm/PatientForm';
import { useNavigate, useParams } from 'react-router-dom';
import { usePatientService } from '../../hooks';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../store/loader';

export const SetPatient = () => {
  const PatientService = usePatientService();
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [patient, setPatient] = useState<Patient>({
    address: '',
    birthDate: new Date(),
    cellphone: '',
    city: '',
    civilStatus: '',
    email: '',
    gender: '',
    name: '',
    phone: '',
    ssn: '',
    state: ''
  });

  const [isFormValid, setIsFormValid] = useState<boolean>(true);

  const isLoading = (state: boolean) => {
    dispatch(loaderActions.setLoading(state));
  };

  useEffect(() => {
    if (params.id && params.id !== 'crear') {
      isLoading(true);

      PatientService.findOneById(params.id)
        .then((data) => setPatient(data))
        .catch((e) => navigate('/pacientes'))
        .finally(() => isLoading(false));
    }
  }, []);

  const savePatient = () => {
    if (!isFormValid) return;

    isLoading(true);

    PatientService.set(patient)
      .then((newPatient) => navigate(`/pacientes/${newPatient.id!}`))
      .catch((e) => console.log(e))
      .finally(() => isLoading(false));
  };

  return (
    <SidebarLayout>
      <h3>Información del paciente</h3>
      <PatientForm
        isValid={isFormValid}
        patient={patient}
        onPatientChanged={setPatient}
        onFormUpdated={setIsFormValid}
      />
      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
        <Button sx={{ mt: 3 }} variant='contained' onClick={savePatient} disabled={!isFormValid}>
          Guardar
        </Button>
      </Box>
    </SidebarLayout>
  );
};
